
import './App.css';
import { createBrowserRouter,RouterProvider } from 'react-router-dom';
import Home from './components/Home/Home';
import Navbar from './components/Navbar/Navbar';
import About from './components/About/About';
function App() {

  const router = createBrowserRouter([
{path: "/",
  element: <Home/>
},
{path: "/about",
  element: <About/>
}


  ])



  return (
    <div className="App">
      <Navbar/>
       <RouterProvider router={router} />
    </div>
  );
}

export default App;
